const SenecFlagDeGermany = () => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img">
        <rect width={24} height={24} fill="white" />
        <g clipPath="url(#senec__clip0_433_28885)">
            <path fillRule="evenodd" clipRule="evenodd" d="M2 14H22V19H2V14Z" fill="#FFD018" />
            <path fillRule="evenodd" clipRule="evenodd" d="M2 9H22V14H2V9Z" fill="#E31D1C" />
            <path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V9H2V4Z" fill="#272727" />
        </g>
        <rect x={2.5} y={4.5} width={19} height={14} rx={1.5} stroke="black" strokeOpacity={0.08} />
        <defs>
            <clipPath id="senec__clip0_433_28885">
                <rect x={2} y={4} width={20} height={15} rx={2} fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default SenecFlagDeGermany;
